import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';

import { Typography } from '../Typography/Typography';
import { Chip } from '../Chip/Chip';
import { Icon } from '../Icon/Icon';

import { TagItem } from './types';

interface HeaderProps {
  title: string;
  description: string;
  tags?: TagItem[];
}

export const Header: FC<HeaderProps> = ({ title, description, tags }) => {
  const theme = useTheme();

  return (
    <Box px={3} pt={3} pb={2} bgcolor="background.paper">
      <Typography variant="h4" gutterBottom>
        {title}
      </Typography>

      {/* Tags */}
      {tags && tags.length > 0 && (
        <Box display="flex" gap={1} mb={2} flexWrap="wrap">
          {tags.map((tag) => (
            <Chip
              key={tag.id}
              label={
                <Box display="flex" alignItems="center" gap="8px">
                  {tag.icon ? (
                    <img
                      src={tag.icon}
                      alt=""
                      style={{
                        width: '16px',
                        height: '16px',
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <Icon
                      name="pricetags-outline"
                      size="medium"
                      fill={theme.palette.text.secondary}
                    />
                  )}
                  {tag.name}
                </Box>
              }
              sx={{
                ...(tag.color && {
                  background: tag.color,
                }),
                ...(tag.borderColor && {
                  border: `1px solid ${tag.borderColor}`,
                }),
                color: theme.palette.text.primary,
              }}
              size="medium"
            />
          ))}
        </Box>
      )}

      <Typography variant="body1">{description}</Typography>
    </Box>
  );
};

export default Header;
